var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 1200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#54575a;}.cls-3{fill:#ec951a;}.cls-4{fill:#47b972;}.cls-5{fill:#94eab3;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 25.5,
    y: 25.5,
    width: 1149,
    height: 1149,
    rx: 95.94,
    ry: 95.94
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1078.56,35.5a86.26,86.26,0,0,1,85.94,85.94v957.11a86.26,86.26,0,0,1-85.94,85.94H121.44a86.26,86.26,0,0,1-85.94-85.94V121.44A86.26,86.26,0,0,1,121.44,35.5h957.11m0-20H121.44C63.18,15.5,15.5,63.18,15.5,121.44v957.11c0,58.27,47.68,105.94,105.94,105.94h957.11c58.27,0,105.94-47.68,105.94-105.94V121.44c0-58.27-47.68-105.94-105.94-105.94Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M264,323.5A98.5,98.5,0,1,1,362.5,225,98.61,98.61,0,0,1,264,323.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M264,134a91,91,0,1,1-91,91,91.1,91.1,0,0,1,91-91m0-15A106,106,0,1,0,370,225,106,106,0,0,0,264,119Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M419.75,1072.5a48.78,48.78,0,0,1-42.41-72.9l321.25-565a48.78,48.78,0,0,1,84.81,0l321.25,565a48.78,48.78,0,0,1-42.41,72.9Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M741,417.45a40.83,40.83,0,0,1,35.89,20.88l321.25,565a41.28,41.28,0,0,1-35.89,61.69H419.75a41.28,41.28,0,0,1-35.89-61.69l321.25-565A40.83,40.83,0,0,1,741,417.45m0-15a55.74,55.74,0,0,0-48.93,28.46l-321.25,565c-21.33,37.52,5.76,84.1,48.93,84.1h642.51c43.16,0,70.26-46.58,48.93-84.1l-321.25-565A55.74,55.74,0,0,0,741,402.45Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M133.75,1072.5a48.78,48.78,0,0,1-42.41-72.9L253.59,714.25a48.78,48.78,0,0,1,84.81,0L500.66,999.6a48.78,48.78,0,0,1-42.41,72.9Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M296,697.08A40.83,40.83,0,0,1,331.89,718l162.25,285.35A41.28,41.28,0,0,1,458.25,1065H133.75a41.28,41.28,0,0,1-35.89-61.69L260.11,718A40.83,40.83,0,0,1,296,697.08m0-15a55.74,55.74,0,0,0-48.93,28.46L84.82,995.9c-21.33,37.52,5.76,84.1,48.93,84.1H458.25c43.16,0,70.26-46.58,48.93-84.1L344.93,710.54A55.74,55.74,0,0,0,296,682.08Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.52aec921ac59a221c6a57092373343c5.svg";
export { ForwardRef as ReactComponent };